module.exports = __webpack_public_path__ + "static/media/Iconos_Check_Point_App_Blanco-07.4e265381.svg";